import React from "react"
import PropTypes from "prop-types"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faArrowCircleRight,
  faArrowCircleLeft
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./nav-arrow.scss"

library.add(faArrowCircleRight)
library.add(faArrowCircleLeft)

const NavArrow = ({ direction, active, handleClick }) => {
  return (
    <div
      className={`nav-arrow ${active ? "active" : ""}`}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={`arrow-circle-${direction}`} />
    </div>
  )
}

NavArrow.propTypes = {
  direction: PropTypes.string.isRequired,
  active: PropTypes.bool,
  handleClick: PropTypes.func.isRequired
}
NavArrow.defaultProps = {
  active: true
}

export default NavArrow
